import { render, staticRenderFns } from "./DomainSetting.vue?vue&type=template&id=d59c8f3a"
import script from "./DomainSetting.vue?vue&type=script&lang=js"
export * from "./DomainSetting.vue?vue&type=script&lang=js"
import style0 from "./DomainSetting.vue?vue&type=style&index=0&id=d59c8f3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports